import { render, staticRenderFns } from "./BnoxTradeSection.vue?vue&type=template&id=c92207f4&scoped=true"
import script from "./BnoxTradeSection.vue?vue&type=script&lang=js"
export * from "./BnoxTradeSection.vue?vue&type=script&lang=js"
import style0 from "./BnoxTradeSection.vue?vue&type=style&index=0&id=c92207f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92207f4",
  null
  
)

export default component.exports